import { render, staticRenderFns } from "./InfoCardSoc.vue?vue&type=template&id=4d7ca9fc&scoped=true&"
import script from "./InfoCardSoc.vue?vue&type=script&lang=js&"
export * from "./InfoCardSoc.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardSoc.vue?vue&type=style&index=0&id=4d7ca9fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7ca9fc",
  null
  
)

export default component.exports